export default {
  no_mobile_app: 'Mobiilisovellusta ei ole määritetty',
  mobile_app_not_live: 'Mobiilisovellus ei ole julkaistu',
};
